import { createContext } from 'react';
import { HomePageRootStore } from '../store/index.store';

export const HomePageStoreContext = createContext<HomePageRootStore>(new HomePageRootStore());
